<template>
  <div class="footer">
    <div class="footer-box show-flex-box-c">
      <div class="top-content show-flex-box-r">
        <dl
          v-for="(item, index) in footerMsgList"
          :key="index"
          class="left-content"
          v-if="index <= 3"
        >
          <dt>{{ item.name }}</dt>
          <dd
            v-for="(cItem, cIndex) in item.items"
            :key="cIndex"
            class="show-flex-box-r"
          >
            <strong v-if="cItem.title != null">{{ cItem.title }}</strong>
            <span
              :class="{ 'go-href': cItem.href }"
              @click="cItem.href && routeLinkTo(cItem.href)"
              >{{ cItem.name }}</span
            >
          </dd>
        </dl>
        <ul class="third-contact show-flex-box-r">
          <li class="third-wb">
            <!-- <a href="https://weibo.com/imarsclub" target="view_window"
              ><strong></strong
            ></a> -->
          </li>
          <li class="third-wx">
            <!-- <strong></strong> -->
            <div class="third-icon show-flex-box-r">
              <!-- <span
                ><img
                  src="../../assets/smallProgram.jpg"
                  alt="德阳经开科创创新创客中心"
                /><em>扫码关注小程序</em></span
              > -->
              <span
                ><img src="../../assets/public.jpg" alt="德阳经开科创创新创客中心" /><em
                  >扫码关注公众号</em
                ></span
              >
              <!-- <span
                ><img src="../../assets/androidApp.jpg" alt="德阳经开科创创新创客中心" /><em
                  >扫码下载安卓App</em
                ></span
              > -->
            </div>
          </li>
        </ul>
      </div>
      <dl class="bottom-record show-flex-box-r show-flex-center">
        <dt v-if="footerCopyright">
          <span>{{
            footerCopyright.merge ? footerCopyright.merge : copyrightContent
          }}</span>
        </dt>
        <dd v-if="footerCopyright">
          <span @click="routeLinkTo('http://beian.miit.gov.cn')">{{
            footerCopyright.aq ? footerCopyright.aq : recordNumber
          }}</span>
        </dd>
      </dl>
      <dl class="bottom-record-center show-flex-box-r show-flex-center">
        <dt class="show-flex-box-r" v-if="footerCopyright">
          <span>{{ centerContentL }}</span>
          <strong></strong>
          <span>{{ centerContentR }}</span>
        </dt>
        <dd v-if="footerCopyright">
          <span @click="routeTo()">营业执照</span>
        </dd>
      </dl>
      <div class="supervisory-unit-box show-flex-box-r show-flex-center">
        <span>平台维修支持单位：四川瑞信汇德教育咨询有限公司</span>
      </div>
    </div>
  </div>
</template>

<script>
import regex from "@/filter/regex";

export default {
  name: "publicFooter",
  data() {
    return {
      footerMsgList: [],
      userInfo: {},
      logined: false,
      footerCopyright: false,
      copyrightContent:
        "Copyright ©2018 德阳经开区科学教育研究培训中心 All rights reserved.",
      recordNumber: "蜀ICP备2021001470号-1",
      centerContentL:
        "德阳经开区科学教育研究培训中心  龙礼江 电话：13541710336  |",
      centerContentR:
        "德阳市市场监管局经开区分局 投诉举报电话：12315 |",
    };
  },
  created() {
    this.getCopyrightInfo();
  },
  mounted() {
    this.checkUserStatus();
    this.getFootSlider();
  },
  updated() {
    this.checkUserStatus();
  },
  computed: {
    listenUserInfo: function () {
      return this.$store.state.user;
    },
  },
  methods: {
    getFootSlider: function () {
      let vSelf = this;
      this.$client
        .getFootSlider()
        .then((res) => {
          vSelf.footerMsgList = res.data;
        })
        .catch((err) => {});
    },
    getCopyrightInfo: function () {
      this.$client
        .getFooterCopyrightInfo()
        .then((res) => {
          this.footerCopyright = res.data || true;
        })
        .catch((err) => {
          console.log(JSON.stringify(err));
        });
    },
    routeLinkTo: function (href) {
      var cur = ["imarsclub", "xueqiusoft", "9090"];
      if (regex.isInsideNetwork(cur, href)) {
        window.open(href, "_self");
      } else {
        window.open(href, "_blank");
      }
    },
    checkUserStatus: function () {
      let userStore = this.$store.state.user;
      let userStatus = regex.isTrueResult(userStore);

      if (userStatus) {
        this.userInfo = this.formatUserInfoByType(userStore);
        this.logined = true;
      } else {
        this.userInfo = null;
        this.logined = false;
      }
    },
    //用户信息数据类型转换
    formatUserInfoByType: function (userStore) {
      let dataType = typeof userStore;
      let userObj = userStore;

      if (dataType == "string") {
        userObj = $.parseJSON(userStore);
      }

      return userObj;
    },
    routeTo: function () {
      this.$router.push({ path: "/web/home/license" });
    },
  },
  watch: {
    listenUserInfo: function () {
      this.checkUserStatus();
    },
  },
};
</script>

<style lang="less" scoped>
img {
  display: none;
}
.footer {
  background: #f0f1f5;
  .footer-box {
    //  height: 300px;
    justify-content: space-between;
    align-items: center;
    .top-content {
      width: 1200px;
      height: 196px;
      padding-top: 50px;
      justify-content: space-between;
      & > dl {
        & > dt {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 28px;
          color: #666;
        }
        & > dd {
          align-items: center;
          & > strong {
            display: block;
            font-size: 14px;
            margin-right: 4px;
            margin-bottom: 15px;
            color: #555;
          }
          & > span {
            display: block;
            font-size: 14px;
            margin-bottom: 15px;
            color: #555;
          }
          & > span.go-href {
            cursor: pointer;
          }
          & > span.go-href:hover {
            color: #f38900;
          }
        }
      }
      & > dl:nth-child(1),
      & > dl:nth-child(2),
      & > dl:nth-child(3) {
        & > dd {
          & > span:hover {
            color: #f38900;
          }
        }
      }
      & > ul {
        position: relative;
        padding-left: 100px;
        .third-wb {
          margin-right: 76px;
          & > a {
            display: block;
            width: 24px;
            height: 20px;
            background-image: url("../../assets/public/footer/home_wb.png");
            background-size: 24px 20px;
          }
        }
        .third-wx {
          & > strong {
            display: block;
            width: 24px;
            height: 20px;
            background-image: url("../../assets/public/footer/home_wx.png");
            background-size: 24px 20px;
          }
          & > .third-icon {
            margin-left: -145px;
            padding-top: 20px;
            & > span {
              margin-left: 10px;
              & > img {
                display: block;
                width: 94px;
                height: 94px;
              }
              & > em {
                display: block;
                font-size: 12px;
                text-align: center;
                font-style: normal;
                margin-top: 13px;
                color: #555;
              }
            }
          }
        }
      }
      & > ul:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 1px;
        height: 141px;
        background: #ddd;
      }
    }
    .bottom-record {
      width: 100%;
      height: 30px;
      background: #e1e3ea;
      //  padding-bottom: 10px;
      & > dt {
        margin-right: 50px;
      }
      span {
        font-size: 12px;
        color: #555;
      }
      & > dd {
        & > span {
          cursor: pointer;
        }
        & > span:hover {
          text-decoration: underline;
        }
      }
    }
    .bottom-record-center {
      width: 100%;
      height: 20px;
      background: #e1e3ea;
      & > dt {
        margin-right: 10px;
        & > strong {
          width: 18px;
          height: 18px;
          background: url("../../assets/card.png") no-repeat center center;
          background-size: 18px 18px;
          margin-left: 10px;
        }
      }
      span {
        font-size: 12px;
        line-height: 20px;
        color: #555;
      }
      & > dd {
        & > span {
          cursor: pointer;
        }
        & > span:hover {
          text-decoration: underline;
        }
      }
    }
    &>.supervisory-unit-box {
      width: 100%;
      background: #e1e3ea;
      padding-bottom: 10px;
      &>span {
        font-size: 12px;
        line-height: 20px;
        color: #555;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/mars_box_footer_cpn.vue